import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Delete a piece of information
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeleteInformation = packet => {
  return {
    type: 'REQUEST_DELETE_INFORMATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveDeleteInformationSuccess = data => ({
  type: 'RECEIVE_DELETE_INFORMATION_SUCCESS',
  data
})

export const receiveDeleteInformationFail = data => ({
  type: 'RECEIVE_DELETE_INFORMATION_FAIL',
  data
})

export const tryToDeleteInformation = packet => (dispatch, getState) => {

  dispatch(requestDeleteInformation(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/' + packet.knowledge_id + '/information/' + packet.id, {
      method: 'delete',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveDeleteInformationSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveDeleteInformationFail({errors:e, lastSubmit: packet}));
    })
}
